import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchLotsAuctionByIdAuction({ dispatch }, idAuction) {
        const { data, status } = await Vue.axios.get(`/lots_auctions/auctions_id/${idAuction}/all`);
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createLotAuction({ dispatch }, lotAuction) {
        const { data, status } = await Vue.axios.post("/lots_auctions", lotAuction);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updateLotAuction({ dispatch }, lotAuction) {
        const { data, status } = await Vue.axios.post(`/lots_auctions/${lotAuction.id}`, lotAuction);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removeLotAuction({ dispatch }, lotAuction) {
        const { data, status } = await Vue.axios.delete(`/lots_auctions/${lotAuction.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }